module.exports = __webpack_public_path__ + "img/public/siteImages/chatIcon.svg?e39a2ad0";